import { stripIssueRefs } from '../utils/presentation';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { helpService, Release } from '../services/help';
import '../components/Help/Help.css';

/** Render only bold text and HTTP(S) links; React escapes everything else. */
export function BulletMarkdown({ text }: { text: string }) {
  const tokens = text.split(/(\*\*[^*]+\*\*|\[[^\]]+\]\([^\s)]+\))/g);
  return <>{tokens.map((token, index) => {
    if (token.startsWith('**') && token.endsWith('**')) return <strong key={index}>{token.slice(2, -2)}</strong>;
    const link = /^\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)$/.exec(token);
    return link ? <a key={index} href={link[2]} target="_blank" rel="noopener noreferrer">{link[1]}</a> : <React.Fragment key={index}>{token}</React.Fragment>;
  })}</>;
}

/** Show the caller-visible release history and remember the newest entry. */
export default function WhatsNew() {
  const { currentUser, setCurrentUser } = useAuth();
  const [releases, setReleases] = useState<Release[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    helpService.releases().then(async rows => {
      if (!active) return;
      setReleases(rows); setLoading(false);
      if (rows[0]) {
        try { const user = await helpService.saveState({ last_seen_release: rows[0].version }); if (active) setCurrentUser(user); }
        catch { if (active) setError('Release notes loaded, but we could not save your reading progress.'); }
      }
    }).catch(() => { if (active) { setLoading(false); setError('Could not load release notes. Please reload to try again.'); } });
    return () => { active = false; };
  }, [currentUser?.id, setCurrentUser]);
  return <div className="page"><h1>What's new</h1>{loading && <p>Loading release notes…</p>}{error && <p role="alert">{error}</p>}
    {!loading && !error && !releases.length && <p>No release notes yet.</p>}
    {releases.map(release => <article className="release-card" key={release.version}>
      <h2>v{release.version} · {release.title}</h2><p>{release.date ? release.date.split('-').reverse().join('/') : 'Unreleased'}</p>
      {release.sections.map((section, index) => <details key={`${section.heading}-${index}`} open><summary>{section.heading}</summary><ul>{section.items.map((item, i) => <li key={i}><BulletMarkdown text={currentUser?.role === 'h2okay_admin' ? item : stripIssueRefs(item)} /></li>)}</ul></details>)}
    </article>)}
  </div>;
}
